import { getLastChar, convertNameToSortNumber } from './sites.util';

export const enhanceSiteTurbine = (turbineConf) => {
    const turbine = {
        ...turbineConf,
        fullName: turbineConf.id,
        string: getLastChar(turbineConf.name),
        numericName: convertNameToSortNumber(turbineConf.name),
    };
    return turbine;
};
